import { render } from "./CompanyIndex.vue?vue&type=template&id=49b67138"
import script from "./CompanyIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Production/Company/CompanyIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49b67138"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49b67138', __exports__)) {
    api.reload('49b67138', __exports__)
  }
  
  module.hot.accept("./CompanyIndex.vue?vue&type=template&id=49b67138", () => {
    api.rerender('49b67138', render)
  })

}


export default __exports__